const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const dateTime = new Intl.DateTimeFormat('en-IN', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
const timeOnly = new Intl.DateTimeFormat('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false });
const dayMonth = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' });
const weekdayDay = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric' });

/** "28 Sept, 14:05" */
export function formatDateTime(value: Date | string | number): string {
  return dateTime.format(new Date(value));
}

/** "14:05" */
export function formatClock(value: Date | string | number): string {
  return timeOnly.format(new Date(value));
}

/** "just now", "4 min ago", "3 h ago", "2 d ago" */
export function formatRelative(value: Date | string, now = Date.now()): string {
  const diff = now - new Date(value).getTime();
  if (diff < MINUTE) return 'just now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)} min ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)} h ago`;
  return `${Math.floor(diff / DAY)} d ago`;
}

/** Axis tick label; granularity follows the visible span. */
export function axisTimeFormatter(spanMs: number): (date: Date) => string {
  if (spanMs <= 1.5 * DAY) return (d) => timeOnly.format(d);
  if (spanMs <= 8 * DAY) return (d) => weekdayDay.format(d);
  return (d) => dayMonth.format(d);
}

/** "5 min", "2 h", "1 d" */
export function formatDuration(ms: number): string {
  if (ms >= DAY) return `${Math.round(ms / DAY)} d`;
  if (ms >= HOUR) return `${Math.round(ms / HOUR)} h`;
  return `${Math.round(ms / MINUTE)} min`;
}
